import { render } from "./success.vue?vue&type=template&id=7898cbf6&scoped=true"
import script from "./success.vue?vue&type=script&lang=js"
export * from "./success.vue?vue&type=script&lang=js"

import "./success.vue?vue&type=style&index=0&id=7898cbf6&lang=less&scoped=true"

import exportComponent from "D:\\rwkj\\suershouyyph-mobile\\保安端\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7898cbf6"]])

export default __exports__